export function ProgressSteps({ currentStep }) {
  return (
    <div className="bg-white rounded-full p-6 relative">
      <div className="flex justify-between items-center max-w-3xl mx-auto relative">
        {/* Step 1 */}
        <div className="flex flex-col items-center relative z-10">
          <div className={`h-10 w-10 rounded-full flex items-center justify-center ${
            currentStep >= 1 ? 'bg-[#556B2F]' : 'bg-gray-300'
          }`}>
            <span className="text-white font-medium">1</span>
          </div>
          <span className="text-sm mt-2 text-[#556B2F]">Select Type</span>
        </div>

        {/* Step 2 */}
        <div className="flex flex-col items-center relative z-10">
          <div className={`h-10 w-10 rounded-full flex items-center justify-center ${
            currentStep >= 2 ? 'bg-[#556B2F]' : 'bg-gray-300'
          }`}>
            <span className="text-white font-medium">2</span>
          </div>
          <span className="text-sm mt-2 text-[#556B2F]">Basic Info</span>
        </div>

        {/* Step 3 */}
        <div className="flex flex-col items-center relative z-10">
          <div className={`h-10 w-10 rounded-full flex items-center justify-center ${
            currentStep >= 3 ? 'bg-[#556B2F]' : 'bg-gray-300'
          }`}>
            <span className="text-white font-medium">3</span>
          </div>
          <span className="text-sm mt-2 text-[#556B2F]">Details</span>
        </div>

        {/* Progress Line */}
        <div className="absolute top-5 left-0 right-0 h-[2px] bg-gray-200 z-0">
          <div 
            className="h-full bg-[#556B2F] transition-all duration-300"
            style={{ width: `${(currentStep - 1) * 50}%` }}
          />
        </div>
      </div>
    </div>
  )
}